import React from "react";
import PropTypes from "prop-types";
import { Image } from "@sparefoot/react-commons";
import { StarRating } from "components/review/StarRating";
import { formatTimestamp } from "utils/dateUtils";
import GoogleLogo from "assets/icons/google-wordmark.svg";
import GoogleIcon from "assets/icons/google.svg";
import "./GoogleReviewCard.scss";

const fixMojibake = (text) => {
	if (!text) return text;

	if (typeof TextDecoder === 'undefined') {
		return text;
	}

	try {
		// \xC3[\x80-\xBF] = accented chars, \xE2\x80[...] = punctuation, \xC2[\x80-\xBF] = Latin-1 supplement
		const hasMojibake = /\xC3[\x80-\xBF]|\xE2\x80[\x93\x94\x98\x99\x9C\x9D]|\xC2[\x80-\xBF]/.test(text);

		if (!hasMojibake) {
			return text;
		}

		const bytes = [];
		for (let i = 0; i < text.length; i += 1) {
			bytes.push(text.charCodeAt(i) % 256);
		}

		const utf8Decoder = new TextDecoder('utf-8');
		const uint8Array = new Uint8Array(bytes);
		const decoded = utf8Decoder.decode(uint8Array);

		// Only use decoded version if it reduced high bytes
		const decodedHighBytes = (decoded.match(/[\x80-\xFF]/g) || []).length;
		const originalHighBytes = (text.match(/[\x80-\xFF]/g) || []).length;

		return decodedHighBytes < originalHighBytes ? decoded : text;
	} catch (e) {
		return text;
	}
};

const GoogleReviewCard = ({
	reviewerName,
	reviewerPhoto,
	rating,
	reviewDate,
	reviewText
}) => {
	const displayText = fixMojibake(reviewText);
	const displayName = fixMojibake(reviewerName);

	return (
		<div className="google-review-card">
			<div className="google-review-card__header">
				<Image
					className="google-review-card__avatar"
					src={reviewerPhoto || GoogleIcon}
					alt={`${displayName}'s profile`}
					referrerPolicy="no-referrer"
				/>
				<span className="google-review-card__name">{displayName}</span>
				<Image
					src={GoogleLogo}
					alt="Google"
					className="google-review-card__google-logo"
				/>
			</div>

			<div className="google-review-card__meta">
				<StarRating
					outOf={5}
					rating={rating}
				/>
				{reviewDate && (
					<>
						<span className="google-review-card__date">
							{formatTimestamp(reviewDate, "review")}
						</span>
					</>
				)}
			</div>

			<p className="google-review-card__text">{displayText}</p>
		</div>
	);
};

GoogleReviewCard.propTypes = {
	reviewerName: PropTypes.string.isRequired,
	reviewerPhoto: PropTypes.string,
	rating: PropTypes.number.isRequired,
	reviewDate: PropTypes.number,
	reviewText: PropTypes.string
};

export default GoogleReviewCard;
